import { FC, forwardRef, useImperativeHandle, useState } from 'react';
import { useMethods } from '@lhb/hook';
import styles from '../index.module.less';
import { Modal } from 'antd';

/**
 * 预测说明
 * @description
 * @demo
 */
const Component:FC<{
  /** 查看示例 */
  showExample?: any,
  ref?: any,
}> = forwardRef(({ showExample }, ref) => {

  useImperativeHandle(ref, () => ({
    init: methods.init,
  }));

  /* state */

  const [open, setOpen] = useState(false);

  /* hooks */

  /* methods */
  const methods = useMethods({

    init() {
      setOpen(true);
    },

    handleCancel() {
      setOpen(false);
    },

    /** 查看示例 */
    showExample() {
      setOpen(false);
      showExample?.();
    },

  });

  return (<Modal
    open={open}
    title='AI进店率预测'
    // onOk={handleOk}
    onCancel={methods.handleCancel}
    width='fit-content'
    footer={null}
    className={styles.predictExplanationModal}
  >
    <div className={styles.predictExplanation}>
      <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/predict_content.png`} className={styles.predictContent} />
      <div className={styles.button} onClick={methods.showExample}>
        <img src={`${process.env.STATIC_RES_DOMAIN}/project-custom/locationpc/chancepoint/ai-predict-entry-rate/icon_predict_example.png`} className={styles.icon} />
        <span className={styles.text}>查看示例</span>
      </div>
    </div>
  </Modal>);
});

export default Component;
